import { Dna } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { nearlabPricing } from "@/data/serviceData";
const DNAPricingTable = () => {
  const dnaTests = [{
    key: "legalPaternity",
    name: "Legal Paternity Testing",
    description: "Court-admissible with chain of custody",
    ...nearlabPricing.dna.legalPaternity
  }, {
    key: "nonLegalPaternity",
    name: "Non-Legal Paternity Testing",
    description: "Peace of mind testing only",
    ...nearlabPricing.dna.nonLegalPaternity
  }, {
    key: "prenatalPaternity",
    name: "Prenatal Paternity Testing",
    description: "Non-invasive from 8 weeks",
    ...nearlabPricing.dna.prenatalPaternity
  }, {
    key: "immigration",
    name: "Immigration DNA Testing",
    description: "AABB-accredited for visa applications",
    ...nearlabPricing.dna.immigration
  }, {
    key: "grandparentage",
    name: "Grandparentage Testing",
    description: "When alleged father unavailable",
    ...nearlabPricing.dna.grandparentage
  }, {
    key: "sibling",
    name: "Sibling DNA Testing",
    description: "Full or half sibling determination",
    ...nearlabPricing.dna.sibling
  }];
  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Dna className="h-6 w-6" />
          DNA Testing Services
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Test Type</TableHead>
              <TableHead>Description</TableHead>
              <TableHead>Price</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {dnaTests.map((test) => (
              <TableRow key={test.key}>
                <TableCell className="font-medium">{test.name}</TableCell>
                <TableCell>{test.description}</TableCell>
                <TableCell>
                  {typeof test.price === 'string' ? (
                    <Badge variant="outline">{test.price}</Badge>
                  ) : (
                    <span className="font-semibold">${test.price}</span>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
export default DNAPricingTable;